import { useAppQuery } from 'services/reactQuery/useAppQuery';
import ParentHTTPService from 'services/HTTPService/parent/ParentHTTPService';
import { useCurrentChild } from 'jotaiAtoms/currentChild';

export const useChildDetailsPageNetworkManage = () => {
    const { id: childId } = useCurrentChild();

    const {
        data: childDetailsData,
        isFetching: isChildDetailsFetching,
        isError: isChildDetailsError,
    } = useAppQuery('CHILD', [childId], () => ParentHTTPService.children.getChild(childId), {});

    const {
        data: settlementChildDetails,
        isFetching: isSettlementChildDetailsFetching,
        isError: isSettlementChildDetailsError,
    } = useAppQuery(
        'SETTLEMENT_CHILD_DETAILS',
        [],
        ParentHTTPService.settlements.getSettlementForChild,
    );

    const {
        data: dietDetails,
        isFetching: isDietDetailsFetching,
        isError: isDietDetailsError,
    } = useAppQuery('DIETS_CHILD_DETAILS', [], ParentHTTPService.diets.getDietForChild, {});

    return {
        isChildDetailsFetching,
        isChildDetailsError,
        childDetailsData,
        isSettlementChildDetailsFetching,
        isSettlementChildDetailsError,
        settlementChildDetails,
        isDietDetailsFetching,
        isDietDetailsError,
        dietDetails,
    };
};
